import type { ReactNode } from "react";
import type { Direction } from "../shared/types";

export function DirectionBadge({ direction, compact = false }: { direction: Direction; compact?: boolean }) {
  return <span className={`category-badge ${compact ? "compact" : ""}`} style={{ "--category": direction.color } as React.CSSProperties}>
    <span className="category-dot" />{direction.name}
  </span>;
}

export function DirectionSelect(props: { directions: Direction[]; value: string; onChange: (value: string) => void; id?: string }) {
  return <select id={props.id} value={props.value} onChange={(event) => props.onChange(event.target.value)}>
    {props.directions.map((direction) => <option key={direction.id} value={direction.id}>{direction.name}</option>)}
  </select>;
}

export function Modal({ title, children, onClose, wide = false }: { title: string; children: ReactNode; onClose: () => void; wide?: boolean }) {
  return <div className="modal-backdrop" role="presentation" onMouseDown={(event) => event.target === event.currentTarget && onClose()}>
    <section className={`modal-card ${wide ? "wide" : ""}`} role="dialog" aria-modal="true" aria-label={title}>
      <header className="modal-header"><h2>{title}</h2><button className="icon-button" onClick={onClose} aria-label="关闭">×</button></header>
      {children}
    </section>
  </div>;
}

export function LoadingBlock({ label = "正在读取…" }: { label?: string }) {
  return <div className="loading-block"><span className="spinner" />{label}</div>;
}

export function EmptyState({ title, detail }: { title: string; detail: string }) {
  return <div className="empty-state"><div className="empty-mark">○</div><strong>{title}</strong><p>{detail}</p></div>;
}

export function ErrorBanner({ message, onDismiss }: { message: string; onDismiss?: () => void }) {
  return <div className="error-banner" role="alert"><span>{message}</span>{onDismiss && <button onClick={onDismiss}>关闭</button>}</div>;
}

export function StatCard({ label, value, detail, tone }: { label: string; value: string; detail?: string; tone?: string }) {
  return <div className="stat-card" style={tone ? { "--tone": tone } as React.CSSProperties : undefined}>
    <span>{label}</span><strong>{value}</strong>{detail && <small>{detail}</small>}
  </div>;
}
